'use client';

import React from 'react';
import {
    onAuthStateChanged,
    getAuth,
} from 'firebase/auth';
import app from '../firebase/firebase';
import { useState, useContext, createContext } from 'react';
import { Loader } from '@mantine/core';
import classes from './AuthContext.module.css';

const auth = getAuth(app);

export const AuthContext = createContext({});

export const useAuthContext = () => useContext(AuthContext);

export const AuthContextProvider = ({
    children,
}) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    React.useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                setUser(user);
            } else {
                setUser(null);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    return (
        <AuthContext.Provider value={{ user }}>
            {loading ? <div className={classes.loader}><Loader type="bars"/></div>
             : children}
        </AuthContext.Provider>
    );
};